import axios from 'axios';

import {
  exitToLogin,
  mapAuthCodeToSessionExitReason,
  shouldSkipSessionExit,
} from '#/utils/auth/sessionExit';
import { getAccess } from '#/utils/auth/tokenStorage';
import { isAuthEnabled } from '#/config/auth';

const request = axios.create({
  baseURL: '/api',
  timeout: 60000,
  headers: {
    'Content-Type': 'application/json',
  },
});

request.interceptors.request.use((config) => {
  if (!isAuthEnabled || config.skipAuth) {
    return config;
  }

  const token = getAccess();
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

request.interceptors.response.use(
  (response) => response,
  (error) => {
    if (
      isAuthEnabled
      && error.response?.status === 401
      && !shouldSkipSessionExit(error, error.config)
    ) {
      const code = error.response?.data?.code;
      exitToLogin({
        reason: mapAuthCodeToSessionExitReason(code),
      });
    }
    return Promise.reject(error);
  },
);

export default request;
